import { BillingBanner } from "../../Component/Banner/BillingBanner";
import { ProgressTrack } from "../../Component/LoadingBar/ProgressTrack";
import { daysLeft, DateFormatter, fIDR } from "../../Service/Helper/Utils";
import { PaymentMethodPicker } from "./Content/Child/PaymentMethodPicker";

// PSB Billing Component
export const PsbBilling = ({ data, rawData }) => {
    const isPaid = data.paid === true || data.status === "paid";
    const costRows = [
        ["Harga Paket", fIDR(data.price), false],
        ["Biaya Instalasi", fIDR(data.instalation_fee), false],
        ["Biaya Member", fIDR(data.member_fee), false],
        [`Jarak Tarikan Gratis`, `${data.max_free_fiber_fee} m`, false],
        [`Jarak Tarikan Terpasang (${data.fiber_pulling_range} m)`, fIDR(data.additional_fiber_fee), false],
        ["Biaya Tambahan", fIDR(data.add_on_price), false],
        ["Diskon Paket", "- " + fIDR(data.discount_item), true],
        ["PPN", fIDR(data.tax_prc), false],
        ["Biaya Administrasi", fIDR(data.administration_fee), false],
    ];

    const tiles = [
            { icon:"fa fa-building", label:"Tanggal Instalasi", val:DateFormatter(data.start_date) },
            { icon:"fa fa-clock", label:"Jatuh Tempo", val:DateFormatter(data.due_date) },
            { icon:"fa fa-calendar", label:"Tanggal Bayar", val:DateFormatter(data.paid_date) },
            { icon:"fa fa-money-bill", label:"Metode Bayar", val:data.paid_type||"-" },
        ]

    return (
    <div style={{ display:"flex", flexDirection:"column", gap:20 }}>
        {/* Hero */}
        <BillingBanner
            type = "psb"
            label = "Instalasi Jaringan"
            id = {data.id}
            itemName = {data.itemName}
            mitraName = {data.mitraName}
            city = {data.city}
            isPaid = {isPaid}
            totalAmount = {fIDR(data.grand_total)}
            paidDate = {data.paid_date}
            paidType = {data.paid_type}
        />

        {/* Key date tiles — full width */}
        <div className="row">
            {tiles.map(({ icon, label, val }) => (
            <div className="col-6 card" key={label} style={{ textAlign:"center", padding:"18px 14px" }}>
                <div style={{ fontSize:26, marginBottom:6 }}>
                    <i className={icon}></i>
                </div>
                <div className="section-title" style={{ marginBottom:4 }}>{label}</div>
                <div style={{ fontSize:14, fontWeight:700, color:"var(--txt)" }}>{val}</div>
            </div>
            ))}
        </div>

        {/* Breakdown + sidebar in a 3-col grid */}
        <div className="billing-3col" style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:16 }}>
            {/* Cost breakdown — spans 2 cols */}
            <div className="card" style={{ gridColumn:"span 2" }}>
                <div className="card-header" style={{ marginBottom:0 }}>
                    <div style={{ fontSize:14, fontWeight:700 }}>Rincian Biaya</div>
                </div>
                <div className="card-body">
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 32px" }}>
                        {costRows.map(([l, v, isDiscount]) => (
                        <div key={l} className="rounded-row">
                            <span className="txt-muted">{l}</span>
                            <span className="txt-val"
                                style={{ color: isDiscount ? "var(--success)" : "var(--txt)" }}>{v}</span>
                        </div>
                        ))}
                    </div>
                    <div
                        style={{ marginTop:14, padding:"14px 0 0", borderTop:"2px solid var(--border2)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <span style={{ fontWeight:700, fontSize:15 }}>Total Tagihan</span>
                        <span
                            style={{ fontWeight:900, fontSize:22, color:"var(--accent)", letterSpacing:"-0.02em" }}>{fIDR(data.grand_total)}</span>
                    </div>
                </div>
            </div>

            {/* Right column: speed + VA + PPPoE */}
            <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
                {/* Speed */}
                <div className="card">
                    <div className="card-body">
                        <div className="section-title">Kecepatan</div>
                        <div className="speed-display">
                            <div className="speed-block">
                                <div className="speed-label">Download</div>
                                <div className="speed-val txt-accent">{data.downlink}</div>
                                <div className="speed-unit">{data.measurement}</div>
                            </div>
                            <div className="speed-divider" />
                            <div className="speed-block">
                                <div className="speed-label">Upload</div>
                                <div className="speed-val" style={{color:"var(--success)"}}>{data.uplink}</div>
                                <div className="speed-unit">{data.measurement}</div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* VA */}
                <div className="card">
                    <div className="card-body">
                        {
                          isPaid
                          ? <><div className="section-title">Tagihan Instalasi Lunas</div></>
                          : ( <>
                                <div className="section-title">Pembayaran Tagihan Instalasi</div>
                                <PaymentMethodPicker
                                data={rawData}
                                />
                            </>
                            )
                        }
                        <div className="divider" />
                        <div className="section-title">PPPoE</div>
                        {[["Username", data.pppoe_username, true], ["Password", data.pppoe_password, true], ["ODP",
                        data.nearest_odp_id, false]].map(([l,v,m]) => (
                        <div className="rounded-row" key={l}><span className="txt-muted">{l}</span><span className={`txt-val
                                ${m?"mono":""}`} style={{ fontSize:m?11:13 }}>{v}</span></div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
};

// INV Billing Component
export const InvBilling = ({ data, fups, rawData }) => {
    const isPsb = data.type === "psb";
    const fup = fups ?? {};

    const total = data.grand_total === "0" ? data.final_price : data.grand_total;
    const startDate = isPsb ? data.start_date : data.start_subscribe;
    const endDate = isPsb ? data.due_date : data.end_subscribe;
    const isPaid = isPsb ? (data.paid === true || data.status === "paid") : data.paidStatus;
    const dueDate = isPaid ? endDate : data.due;
    const rem = daysLeft(dueDate);
    // const prog = pctDoneDate(startDate, dueDate);

    const costRows = [
        [
            "Harga Paket",
            fIDR(data.price),
            false
        ],
        [
            "Diskon",
            "- " + fIDR(data.discount_item),
            true],
        [
            "Biaya Tambahan",
            fIDR(data.add_on_price),
            false
        ],
        [
            "Biaya Admin",
            fIDR(data.administrationFee),
            false
        ],
        [
            "PPN",
            fIDR(data.tax_prc),
            false
        ],
    ];

    const billingStats = [
        [
            "Paket",
            data.itemName
        ],
        [
            "Periode",
            `${data.periodInvoice} ${data.year}`
        ]
    ]

    return (
    <div style={{ display:"flex", flexDirection:"column", gap:20 }}>
        {/* Hero */}
        <BillingBanner
            id = {`#${data.name?.slice(-10)}`}
            type = "inv"
            label = "Tagihan Bulanan"
            fups = {fup}
            itemName = {data.itemName}
            mitraName = {data.mitraName}
            city = {data.city}
            isPaid = {data.paidStatus}
            totalAmount = {fIDR(total)}
            paidDate = {data.paid}
        />

        {/* Period progress — full width card */}
        <div className="card">
            <div className="card-body">
                <div
                    style={{ display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12, marginBottom:16 }}>
                    <div>
                        <div className="section-title" style={{ marginBottom:4 }}>Periode Berlangganan</div>
                        <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                            <span className="badge badge-surface">{DateFormatter(data.start_subscribe)}</span>
                            <span className="txt-muted" style={{ fontSize:16 }}>-</span>
                            <span className="badge badge-surface">{DateFormatter(data.end_subscribe)}</span>
                            {
                            rem <= 7 && <span className="badge badge-danger">
                                <i className="fa fa-exclamation-triangle"></i> Jatuh Tempo {rem} hari lagi!
                            </span>
                            }
                        </div>
                    </div>
                    {/* Masa Aktif big number */}
                    <div style={{ textAlign:"right" }}>
                        <div className="section-title" style={{ marginBottom:2 }}>Masa Aktif</div>
                        <div
                            style={{ fontSize:32, fontWeight:900, letterSpacing:"-0.03em", color: rem<=7?"var(--danger)":rem<=14?"var(--warn)":"var(--accent)", lineHeight:1 }}>
                            {rem <= 0 ? "Habis" : rem}<span
                                style={{ fontSize:14, fontWeight:500, color:"var(--txt3)", marginLeft:4 }}>hari</span></div>
                    </div>
                </div>
                <ProgressTrack
                  min = {startDate}
                  max = {dueDate}
                  isDate = {true}
                  percentText = {"Terpakai"}
                  progressText = {"hari tersisa"}
                />
            </div>
        </div>

        {/* Bottom row: breakdown + speed + VA */}
        <div className="billing-3col" style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:16 }}>
            {/* Cost breakdown — 2 cols */}
            <div className="card" style={{ gridColumn:"span 2" }}>
                <div className="card-header" style={{ marginBottom:0 }}>
                    <div style={{ fontSize:14, fontWeight:700 }}>Rincian Biaya</div>
                </div>
                <div className="card-body">
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 32px" }}>
                        {costRows.map(([l, v, isDiscount]) => (
                        <div key={l} className="rounded-row">
                            <span className="txt-muted">{l}</span>
                            <span className="txt-val"
                                style={{ color: isDiscount ? "var(--success)" : "var(--txt)" }}>{v}</span>
                        </div>
                        ))}
                    </div>
                    <div
                        style={{ marginTop:14, padding:"14px 0 0", borderTop:"2px solid var(--border2)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <span style={{ fontWeight:700, fontSize:15 }}>Total Tagihan</span>
                        <span
                            style={{ fontWeight:900, fontSize:22, color:"var(--accent)", letterSpacing:"-0.02em" }}>{fIDR(total)}</span>
                    </div>
                    {data.paidStatus && (
                    <div className="alert-success" style={{ marginTop:12 }}>
                        <span style={{ fontSize:18 }}></span>
                        <span>Pembayaran diterima pada <strong>{DateFormatter(data.paid)}</strong></span>
                    </div>
                    )}
                </div>
            </div>

            {/* Right: speed + VA */}
            <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
                <div className="card">
                    <div className="card-body">
                        <div className="section-title">Kecepatan Paket</div>
                        <div className="speed-display">
                            <div className="speed-block">
                                <i className="fa fa-download"/>
                                <div className="speed-label">Download</div>
                                <div className="speed-val txt-accent">{data.downlink}</div>
                                <div className="speed-unit">{data.measurement}</div>
                            </div>
                            <div className="speed-divider" />
                            <div className="speed-block">
                                <i className="fa fa-upload"/>
                                <div className="speed-label">Upload</div>
                                <div className="speed-val" style={{color:"var(--success)"}}>{data.uplink}</div>
                                <div className="speed-unit">{data.measurement}</div>
                            </div>
                        </div>
                        <div className="divider" />
                        {billingStats.map(([l,v]) => (
                        <div className="rounded-row" key={l}><span className="txt-muted">{l}</span><span className="txt-val"
                                style={{ fontSize:12, textAlign:"right", maxWidth:"60%" }}>{v}</span></div>
                        ))}
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        {
                          isPaid
                          ? <><div className="section-title">Tagihan Lunas</div></>
                          : ( <>
                                <div className="section-title">Pembayaran Tagihan</div>
                                <PaymentMethodPicker
                                data={rawData}
                                />
                            </>
                            )
                        }
                        <div className="txt-muted" style={{ fontSize:11, textAlign:"center" }}>
                            {
                            !isPaid
                                ? 'tagihan bulanan.'
                                : 'Bukti Pembayaran Anda'
                            } </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
};